var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 9.29935L13.0333 10.4827C13.7192 9.79695 14.2307 8.95682 14.525 8.03268L12.9083 7.62435C12.6417 8.36601 12.2667 8.87435 11.85 9.29935ZM10.8333 4.99935L14.1667 1.66602L17.5 4.99935H14.9833C14.9667 5.67435 14.9167 6.28268 14.825 6.80768L13.2083 6.39935C13.2667 5.99935 13.3083 5.52435 13.3167 4.99935H10.8333ZM2.5 4.99935L5.83333 1.66602L9.16667 4.99935H6.675C6.75833 8.06601 7.74167 8.95768 8.79167 9.89935C9.20833 10.266 9.63333 10.666 10 11.191C10.2833 10.7827 10.6083 10.4577 10.9417 10.1577L12.1167 11.3327C11.3417 12.041 10.8333 12.616 10.8333 14.166V18.3327H9.16667V14.166C9.16667 12.4827 8.575 11.9493 7.675 11.141C6.525 10.1077 5.10833 8.82435 5.00833 4.99935H2.5Z",
    fill: "#805AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditions);
export default __webpack_public_path__ + "static/media/conditions.54e70b3b8b2930be6c2e5c46d007d68c.svg";
export { ForwardRef as ReactComponent };